/**
 * Typed, validated access to `import.meta.env.VITE_*`.
 * Fails loud in dev if a required Firebase var is missing.
 */

function required(key: keyof ImportMetaEnv): string {
  const value = import.meta.env[key];
  if (!value) {
    // eslint-disable-next-line no-console
    console.error(`[env] Missing required env var ${key}. Check apps/customer/.env.local`);
    return '';
  }
  return value;
}

export const firebaseConfig = {
  apiKey: required('VITE_FIREBASE_API_KEY'),
  authDomain: required('VITE_FIREBASE_AUTH_DOMAIN'),
  projectId: required('VITE_FIREBASE_PROJECT_ID'),
  storageBucket: required('VITE_FIREBASE_STORAGE_BUCKET'),
  messagingSenderId: required('VITE_FIREBASE_MESSAGING_SENDER_ID'),
  appId: required('VITE_FIREBASE_APP_ID'),
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
} as const;

export const vapidKey = import.meta.env.VITE_FIREBASE_VAPID_KEY ?? '';

export const useEmulators = import.meta.env.VITE_USE_EMULATORS === 'true';

export type OtpProviderName = 'clerk' | 'email' | 'firebase' | 'msg91' | 'fast2sms' | 'whatsapp';

export const otpProviderName: OtpProviderName =
  (import.meta.env.VITE_OTP_PROVIDER as OtpProviderName | undefined) ?? 'clerk';

/**
 * Deployed Apps Script web-app /exec URL. Serves BOTH the self-hosted email-OTP
 * endpoint (provider 'email') and the Clerk→Firebase token exchange (provider
 * 'clerk'). Required outside emulator mode (the emulator path signs in locally).
 */
export const otpEndpoint: string = import.meta.env.VITE_OTP_ENDPOINT ?? '';

/**
 * Base URL of the sync worker's edge catalog (same worker as VITE_OTP_ENDPOINT
 * by default). Products are fetched from here — one cached request per
 * category instead of a Firestore read per product.
 */
export const catalogEndpoint: string =
  (import.meta.env.VITE_CATALOG_ENDPOINT ?? import.meta.env.VITE_OTP_ENDPOINT ?? '').replace(/\/+$/, '');

/** Clerk publishable key (pk_test_… / pk_live_…). Required for provider 'clerk'. */
export const clerkPublishableKey: string = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY ?? '';
